// @flow
import React from 'react';
import getRoutes from './routes';
import App from './containers/App';

const mapRoutesForUse = (routes, jpApiClient, disableCypressDataFetching) =>
  routes.map((item) => {
    const { path: itemPath, children, element, loader, action } = item;

    const Element = element;

    return {
      path: itemPath,
      element: element ? <Element /> : null,
      loader:
        loader && !disableCypressDataFetching
          ? (params) => loader({ params, jpApiClient })
          : null,
      action: action || (() => null),
      children: children && mapRoutesForUse(children)
    };
  });

export default (jpApiClient, disableCypressDataFetching) => {
  const routes = getRoutes();
  const browserRoutes = mapRoutesForUse(
    routes,
    jpApiClient,
    disableCypressDataFetching
  );

  return [
    {
      element: <App />,
      children: browserRoutes
    }
  ];
};
